// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__Akz_I","footer":"ReportModalFilter_footer__sqkr9"};